import { FC } from 'react';
import Grid from '@material-ui/core/Grid';
import { observer } from 'mobx-react-lite';

import { Partner } from '@constants/paymentLink';

import useStore from '@hooks/useStore';

import { PaymentFormProps, PartnerComponent } from '../types';
import BelvoDirectDebitForm from './BelvoDirectDebitForm';
import useStyles from './styles';

export const getPartner = (partner: Partner): PartnerComponent => {
  switch (partner) {
    case Partner.BELVO:
      return BelvoDirectDebitForm;
    default:
      return BelvoDirectDebitForm;
  }
};

const DirectDebitPaymentForm: FC<PaymentFormProps> = ({ onValidationError }) => {
  const {
    links: {
      paymentConfig: {
        paymentMethods: { directDebit },
      },
    },
  } = useStore();
  const css = useStyles();
  const PartnerForm = getPartner(directDebit.partner as Partner);

  return (
    <div role="tab-panel" className="tab-content card-content" data-testid="card-info-panel">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <PartnerForm onValidationError={onValidationError} apiKey={directDebit.apiKey} />
        </Grid>
      </Grid>
    </div>
  );
};

export default observer(DirectDebitPaymentForm);
